import { GuiDetailBenutzer } from "../D/GuiDetailBenutzer";

// Support-Detail eines Benutzers: gleiches Formular und gleiche Aktionen wie in den Stammdaten
export class GuiDetailSupportBenutzer extends GuiDetailBenutzer {
}
